import React, { useEffect } from 'react';
import Microapp from '@/components/micro-app';
import env from '@/env';
import { CJ_LISTEN_YXHD_HCHDBM } from '@/constants/scene';
import FeedBackLayout from '@/components/feedback-layout';
// 主题活动会场
import { data as defaultData } from '../../constants';
// 我的创建
import createData from '@/pages/activity-manage/my-create/constants/data';
// 新版日常活动
import dailyData from '@/pages/activity-manage/my-create/daily-activities-details-manager/material-pool-manage/material-collection-daily/my-micro-app/data';
// 频道列表
import channelServiceData from '@/pages/channel-service/pages/channel/open-registration-process/collection-list/constants/data';
// 阵地资源位，行业频道
import { platformData, industryData } from '@/pages/platform-marketing-position/resource-detail/contants/data';
import { logsingup } from '@/log';
import { areaDetailV2, formsetAreaDetail, usePerformanceApis } from '@/apiperformance';
import { connect } from 'react-redux';
import { showUserVoice } from '@/components/userVoice';

const allEnvData = { avenueData: defaultData, channelServiceData, createData, dailyData, platformData, industryData };

const performanceApis = [areaDetailV2, () => formsetAreaDetail(2)];
const emptyQueue: [] = [];

function SignUp(props: any) {
  const { data = defaultData, performanceApi = false, ..._props } = props;
  const ref = React.useRef();
  const instanceRef = React.useRef();
  instanceRef.current = props.feedback?.instance;
  function showFeedBack() {
    try {
      //@ts-ignore
      instanceRef.current?.show?.({ sceneKey: 'CJ_LISTEN_YXZX_HCZYW/HCZYW_BM' });
    } catch (error) {
      console.error(error);
    }
  }
  useEffect(() => {
    logsingup();
  }, []);

  // @ts-ignore
  const prefetchApis = usePerformanceApis(performanceApi ? performanceApis : emptyQueue);

  return (
    <>
      {/*@ts-ignore*/}
      <FeedBackLayout showFeedBack={true} scene={CJ_LISTEN_YXHD_HCHDBM.key} ref={ref} />
      <Microapp
        data={{ ...allEnvData, ...data, ...prefetchApis, showFeedBack, showUserVoice }}
        // http://mcbeta.jd.com/dist/pages/activeManageBlock/?entry=0&activityId=10599231
        url={`${env.MC_DOMAIN}/dist/pages/activeResource/enroll/`}
        name="tibaosignup"
        {..._props}
      />
    </>
  );
}
export default connect((state: any) => {
  return {
    feedback: state.feedback,
  };
})(SignUp);
